import React from 'react'
import { MenuItem, Select, FormControl } from '@mui/material'
import { styled } from '@mui/system'
import { PropTypes } from 'prop-types'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useTranslation } from 'react-i18next'
/* costumiser le style du select */
const CustomSelect = styled(Select)({
  '& .MuiSelect-select': {
    padding: '8px 32px 8px 8px', // Custom padding
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none', // Remove the border
  },
  '& .MuiSelect-icon': {
    color: '#0C0401 !mportant', // Set the color of the bottom arrow
  },
})

const SelectStatus = (props) => {
  const { status, statuses, onChange, isDisabled } = props
  const currentStatus = statuses?.find((s) => s.value === status)
  const color = currentStatus ? currentStatus.color : '#000'
  const backgroundColor = currentStatus ? currentStatus.backgroundColor : '#000'
  const { t } = useTranslation('status')
  return (
    <FormControl variant="outlined" size="small" style={{ minWidth: 100 }}>
      <CustomSelect
        value={status ? status : 'incomplete'}
        onChange={onChange}
        style={{
          color: color,
          border: 'none',
          backgroundColor: backgroundColor,
          padding: '0',
        }}
        size="small"
        displayEmpty
        IconComponent={!isDisabled ? ExpandMoreIcon : ''} // Use ExpandMoreIcon for the bottom arrow
        disabled={isDisabled}
      >
        {statuses?.map((status) => (
          <MenuItem key={status.value} value={status.value}>
            {t(`${status.value}`)}
          </MenuItem>
        ))}
      </CustomSelect>
    </FormControl>
  )
}
SelectStatus.propTypes = {
  status: PropTypes.string.isRequired,
  statuses: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  isDisabled: PropTypes.bool,
}
export default SelectStatus
